var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjRouteTabs", {
        attrs: { "route-list": _vm.ORDER_ABNORMAL_FIVE_ROUTE_LIST },
      }),
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "query-params": _vm.queryParams,
          "get-action": _vm.queryApi,
          radio: _vm.radio,
          "before-reset-search": _vm.beforeResetSearch,
          "tooltip-config": { showAll: false, enterable: false },
          selection: _vm.selection,
          "search-btn-hide": true,
        },
        on: {
          handleSelectionChange: _vm.handleSelectionChange,
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
        },
        scopedSlots: _vm._u([
          {
            key: "tableOperation",
            fn: function () {
              return [_c("el-col")]
            },
            proxy: true,
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _vm._l(_vm.dropCols, function (col, index) {
                  return [
                    col.prop !== "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || false,
                            align: "center",
                            "class-name": "item",
                            "show-overflow-tooltip":
                              col.prop !== "bjTableAction",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    false
                                      ? void 0
                                      : col.prop === "outerOrderNo"
                                      ? [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(scope.row.outerOrderNo)
                                            ),
                                          ]),
                                          _c("BjCopyIcon", {
                                            attrs: {
                                              copy: scope.row.outerOrderNo,
                                            },
                                          }),
                                        ]
                                      : col.prop === "innerOrderNo"
                                      ? [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(scope.row.innerOrderNo)
                                            ),
                                          ]),
                                          _c("BjCopyIcon", {
                                            attrs: {
                                              copy: scope.row.innerOrderNo,
                                            },
                                          }),
                                        ]
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("timeFilters")(
                                                scope.row[col.prop],
                                                scope.row[col.prop]
                                              )
                                            )
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                    col.prop === "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || "right",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (props) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "edit-btn",
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onCancel(props.row)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "businessLogisticsCompanyList.done"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                  ]
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }